import { observer } from 'mobx-react';
import * as React from 'react';

import { FilterModel } from './filter-types';

import { CheckboxGroup } from './checkbox-group';
import { FormFieldBinding } from './form-field-binding';
import { SearchFormFieldProps } from 'components/common/search-form';

@FormFieldBinding
@observer
export class PopularFilter extends React.Component<SearchFormFieldProps> {
  public handleChange = event => {
    const target = event.target;
    const { value, filterType } = target;

    const { model, sortAndFilterOptions, updateModel } = this.props;

    const checkbox: FilterModel = sortAndFilterOptions && sortAndFilterOptions[filterType];
    const checkboxName: string = checkbox && checkbox.title;
    const modelValue = model && model[filterType];

    if (typeof updateModel !== 'function' || (!modelValue && modelValue !== '')) {
      return;
    }

    /* add/remove checked/unchecked values from the array */
    let newArrayValue = modelValue.slice();
    const index = newArrayValue.indexOf(value);
    if (index === -1) {
      Array.isArray(newArrayValue) ? newArrayValue.push(value) : (newArrayValue = value);
    } else {
      newArrayValue = Array.isArray(newArrayValue) ? newArrayValue.filter(item => item !== value) : '';
    }

    if ((filterType === 'neighborhood' || filterType === 'poi') && !newArrayValue) {
      newArrayValue =
        sortAndFilterOptions[filterType] && sortAndFilterOptions[filterType].options
          ? sortAndFilterOptions[filterType].options[0].value
          : '';
    }

    updateModel({
      target: {
        name: checkboxName,
        value: newArrayValue,
      },
    });
  };

  private getFilterType(option) {
    return option.filterType;
  }

  private isChecked = option => {
    const { model } = this.props;

    return ((model && model[option.filterType]) || []).includes(option.value);
  };

  public render() {
    return <CheckboxGroup getFilterType={this.getFilterType} isChecked={this.isChecked} handleChange={this.handleChange} {...this.props} />;
  }
}
